import React from "react";
import { StyledButton } from "../../../CommonUI/BuildlingBlocks/StyledButton";
import { DataTypePicker } from "../../../CommonUI/DataTypePicker/DataTypePicker";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { ExpressionEditLayer } from "../../../Expressions/ExpressionEditLayer";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";

interface IExpressionEditUI {
    expression: ExpressionConfiguration;
}

export const ExpressionEditUI = ({ expression }: IExpressionEditUI) => {
    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <UISpacedBoxContent>
            <StyledButton
                sx={{ background: UIStyleConstants.BLUE_COLOR }}
                variant="contained"
                onClick={() => setOpen(true)}
            >
                Edit Expression
            </StyledButton>
            <DataTypePicker
                dataDef={expression.getRuleResult()}
                width={"150px"}
                label={"Expression Result:"}
                updateCallback={(newDef) => {
                    expression.executionResult = newDef;
                }}
            />
            <ExpressionEditLayer
                expression={expression}
                open={open}
                onClose={() => setOpen(false)}
            ></ExpressionEditLayer>
        </UISpacedBoxContent>
    );
};

// const ExpressionLayer = styled.div`
//     min-width: 800px;
//     min-height: 500px;
//     position: relative;
// `;
